import { resolveMediaUrl } from "../../api";
import { formatAddressSummary, formatHuf, formatPickupSummary } from "./checkoutUtils";

function CheckoutOrderSummary({
  t,
  shop,
  shippingMethod,
  pickupPoint,
  shippingAddress,
  billingAddress,
  shippingSameAsBilling = true,
  coffeeImage,
  cartLines = null,
  showContinue = false,
  continueLabel = "",
  continueDisabled = false,
  onContinue,
}) {
  const isCart = Array.isArray(cartLines);
  const coffeePrice = isCart
    ? cartLines.reduce((sum, line) => sum + line.lineTotalHuf, 0)
    : shop?.coffeePriceHuf || 0;
  const shippingFee = shippingMethod
    ? shop?.shipping?.[shippingMethod]?.priceHuf || 0
    : 0;
  const total = coffeePrice + shippingFee;
  const isPickup = shippingMethod === "pickup";
  const isHome =
    shippingMethod === "foxpostHome" || shippingMethod === "glsHome";
  const lockerDetail = formatPickupSummary(pickupPoint, shippingMethod);
  const resolvedShipping = formatAddressSummary(
    shippingSameAsBilling ? billingAddress : shippingAddress,
  );

  return (
    <aside className="checkout-summary-card" aria-label={t.summaryTitle}>
      <h3 className="checkout-summary-title">{t.summaryTitle}</h3>

      {isCart ? (
        cartLines.map((line) => (
          <div key={line.productId} className="checkout-summary-product">
            <img
              src={line.imageUrl ? resolveMediaUrl(line.imageUrl) : "/img/mizulogo.png"}
              alt=""
              className="checkout-summary-thumb"
            />
            <div className="checkout-summary-product-copy">
              <p className="checkout-summary-product-name">
                {line.quantity > 1 ? `${line.quantity} × ` : ""}
                {line.name}
              </p>
              {line.unitLabel ? (
                <p className="checkout-summary-product-size">{line.unitLabel}</p>
              ) : null}
            </div>
            <span className="checkout-summary-product-price">
              {formatHuf(line.lineTotalHuf)}
            </span>
          </div>
        ))
      ) : (
        <div className="checkout-summary-product">
          {coffeeImage ? (
            <img src={coffeeImage} alt="" className="checkout-summary-thumb" />
          ) : null}
          <div className="checkout-summary-product-copy">
            <p className="checkout-summary-product-name">{t.productTitle}</p>
            <p className="checkout-summary-product-size">{t.size}</p>
          </div>
          <span className="checkout-summary-product-price">{formatHuf(coffeePrice)}</span>
        </div>
      )}

      <div className="checkout-summary-divider" />

      <div className="checkout-summary-row">
        <span>{t.subtotalLabel}</span>
        <span>{formatHuf(coffeePrice)}</span>
      </div>
      <div className="checkout-summary-row">
        <span>{t.shippingSummaryLabel}</span>
        <span className={shippingFee === 0 && shippingMethod ? "is-free" : ""}>
          {shippingMethod
            ? shippingFee > 0
              ? formatHuf(shippingFee)
              : t.freeShipping
            : "—"}
        </span>
      </div>

      {isPickup ? (
        <div className="checkout-summary-delivery">
          <p className="checkout-summary-delivery-label">{t.deliveryDetails}</p>
          <p className="checkout-summary-delivery-value">{t.pickupAddress}</p>
        </div>
      ) : null}

      {lockerDetail ? (
        <div className="checkout-summary-delivery">
          <p className="checkout-summary-delivery-label">{t.deliveryDetails}</p>
          <p className="checkout-summary-delivery-value">{lockerDetail}</p>
        </div>
      ) : null}

      {isHome && resolvedShipping ? (
        <div className="checkout-summary-delivery">
          <p className="checkout-summary-delivery-label">{t.addressSectionTitle}</p>
          <p className="checkout-summary-delivery-value">{resolvedShipping}</p>
        </div>
      ) : null}

      <div className="checkout-summary-total">
        <span>{t.totalLabel}</span>
        <span>{formatHuf(total)}</span>
      </div>

      {showContinue ? (
        <button
          type="button"
          className="checkout-summary-cta"
          disabled={continueDisabled}
          onClick={onContinue}
        >
          {continueLabel}
        </button>
      ) : null}

      <p className="checkout-summary-secure">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M12 2a5 5 0 0 1 5 5v2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h1V7a5 5 0 0 1 5-5zm0 2a3 3 0 0 0-3 3v2h6V7a3 3 0 0 0-3-3z"
          />
        </svg>
        {t.securePayment}
      </p>
    </aside>
  );
}

export default CheckoutOrderSummary;
